import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { SIDEBAR_CLOSE } from '../../actions/actions'

class NavLink extends Component {
  respondToClick = () => {
    if (this.props.isBrowserSmall) {
      this.props.dispatch({ type: SIDEBAR_CLOSE })
    }
  }

  render() {
    const pathname = this.props.pathname
    let isActive

    if (this.props.to === '/dashboard') {
      isActive = pathname === this.props.to
    } else {
      // isActive = pathname.includes(this.props.to)
      isActive = pathname === this.props.to
    }

    let activeClassName = isActive ? 'active-nav' : ''

    const to = this.props.disabled ? '/dashboard/profile' : this.props.to

    const shouldBeMiniVersion = !this.props.sidebar.isOpen

    const children = shouldBeMiniVersion
      ? this.props.children[0]
      : this.props.children

    if (this.props.isExternal) {
      return <a
        className={`vertical-menu-item ${activeClassName}`}
        style={{ display: 'block' }}
        onClick={this.respondToClick}
        target="_blank"
        href={to}
      >
        {children}
      </a>
    }

    return (
      <Link
        className={`vertical-menu-item ${activeClassName}`}
        onClick={this.respondToClick}
        style={{ display: 'block' }}
        children={children}
        to={to}
      />
    )
  }
}

// NavLink.contextTypes = {
//   router: PropTypes.object
// }

//just to force this component to re-render when routes change
//otherwise it won't re-render because it has no reason to!

const mstp = state => ({
  sidebar: state.sidebar,
  pathname: state.routing.locationBeforeTransitions.pathname,
  isBrowserSmall: state.browser.lessThan.large
})

export default connect(mstp)(NavLink)



// WEBPACK FOOTER //
// ./src/components/common/NavLink.js